import { isScrolledIntoView, countDecimals } from '~/js/helpers';

function animateValue(obj, start, end, duration) {
	let startTimestamp = null;
	const step = (timestamp) => {
		if (!startTimestamp) {
			startTimestamp = timestamp;
		}
		const progress = Math.min((timestamp - startTimestamp) / duration, 1);
		const decimals = countDecimals(end);
		let animated = (progress * (end - start) + start).toFixed(decimals);
		let formattedNumber = Intl.NumberFormat(document.documentElement.lang, {
			minimumFractionDigits: decimals,
		});
		obj.innerHTML = formattedNumber.format(animated);
		if (progress < 1) {
			window.requestAnimationFrame(step);
		}
	};
	window.requestAnimationFrame(step);
}

const triggerAnimations = () => {
	document.querySelectorAll('section.numbers').forEach((section) => {
		const domElement = section;

		if (isScrolledIntoView(domElement) && !section.dataset.animated) {
			section.querySelectorAll('.number').forEach((elem) => {
				const targetValue = parseFloat(elem.getAttribute('data-value')) || 0;

				if (!isNaN(targetValue)) {
					console.log('Animating:', elem, 'Target Value:', targetValue);
					animateValue(elem, 0, targetValue, 2000);
				}
			});

			section.dataset.animated = 'true';
		}
	});
};

window.addEventListener('scroll', triggerAnimations);
document.addEventListener('DOMContentLoaded', triggerAnimations);
